import React, {Component} from 'react';
import ReactToPrint from 'react-to-print';
import InventoryTransferIdFilter from '../components/InventoryTransferIdFilter';
import InventoryTransferLookupReport from '../components/InventoryTransferLookupReport';
import ReportHeaderState from '../components/ReportHeaderState';
import NoAccess from '../noAccess';
import {hasReportsAccess} from '../shared/authFunctions';
import FuseTheme from '../global/theme';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {Card, CardText} from 'material-ui/Card';
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Avatar from 'material-ui/Avatar';
import Icon from 'material-ui/svg-icons/maps/local-shipping';

export const fuseInventoryTransferLookupReportsIcon = Icon;

const styles = {
    button: {color: FuseTheme.palette.primary3Color},
};

/**
 * Inventory Transfer Lookup Reports class for retrieving and displaying summary
 *
 */
export class InventoryTransferLookupReports extends Component {
    constructor(props) {
        super(props);
        const system = localStorage.getItem('system');
        this.state = {
            errorMessage: null,
            location: {
                id: null,
                name: '',
                city: '',
                state: ''
            },
            selectedTransferId: null,
            summaryComplete: false,
            system: system
        };
    }

    /**
     * Handle event props from InventoryTransferIdFilter
     *
     * @param value
     */
    handleTransferIdSelect = (value) => {
        this.setState({selectedTransferId: value});
    };

    /**
     * Handle event props for Inventory Transfer Lookup Summary table completion
     *
     * @param isComplete
     */
    handleSummaryComplete = (isComplete) => {
        this.setState({
            summaryComplete: isComplete,
        });
    };

    handleReportError = (message) => {
        this.setState({
            errorMessage: message,
            summaryComplete: true,
        });
    };

    render() {
        const {
            errorMessage,
            selectedTransferId,
            summaryComplete,
            system
        } = this.state;

        if (!hasReportsAccess()) return <NoAccess/>;

        const ListTitle = <span className="list-title hide-print">
            <Avatar icon={<Icon/>} className="avatar-title"/>Inventory Transfer Lookup Report</span>;

        const ListDescription = () => {
            return (
                <span className="list-description hide-print">
                    <p>An Inventory Transfer Lookup Report displays all Products in a specific Transfer.</p>
                    <p>Enter a valid Transfer ID to generate a Report:</p>
                </span>
            );
        };

        return (
            <div className="lists-container" ref={e => (this.printReportRef = e)}>
                <Card>
                    <ViewTitle title={ListTitle}/>
                    <CardText>
                        <ListDescription/>

                        {/* Report Filter (Transfer ID) */}
                        <InventoryTransferIdFilter
                            onSubmitTransferId={this.handleTransferIdSelect}
                        />

                        {/* Print Header */}
                        {selectedTransferId &&
                        <ReportHeaderState
                            reportType="Inventory Transfer Lookup Report Summary"
                        />
                        }

                        {/* Inventory Transfer Lookup Report Content */}
                        {selectedTransferId &&
                        <div>

                            {/* Report Header, Loader, and messaging */}
                            <div className="report-header">
                                <div className="btn-print-container report-header-button-container">
                                    <ReactToPrint
                                        trigger={() =>
                                            <RaisedButton
                                                primary
                                                type="button"
                                                label="Print Report"
                                                style={styles.button}
                                            />
                                        }
                                        content={() => this.printReportRef}
                                    />
                                </div>
                                <h2 className="report-header-title">Inventory Transfer Lookup Report</h2>
                            </div>
                            {!summaryComplete &&
                            <div className="loader-container">
                                <h4>Generating Report...</h4>
                                <CircularProgress
                                    size={24}
                                    thickness={2}
                                    className="loader"
                                />
                            </div>
                            }

                            {/* Summary Report */}
                            <InventoryTransferLookupReport
                                transferId={selectedTransferId}
                                onSummaryComplete={this.handleSummaryComplete}
                                onError={this.handleReportError}
                                system={system}
                            />
                        </div>
                        }

                        {/* Error and Messaging */}
                        {errorMessage &&
                            <div className="error">
                                <p>{errorMessage}</p>
                            </div>
                        }
                    </CardText>
                </Card>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/Report/InventoryTransferLookupReports.js